import PropTypes from "prop-types";
import React from "react";
import CountdownTimer from "../CountdownTimer";
import { Button } from "cxa-components";
import moment from "moment";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const formatDate = date => {
  // to get 23:59:59 with previous day
  const subtractedDate = moment(date).subtract(1, "s");
  return subtractedDate.format();
};

const BenefitEnrolment = injectIntl(({ enrolmentInfo, intl }) => (
  <article className="card">
    <header>
      <h2>{intl.formatMessage(messages.endInDescription)}</h2>
    </header>
    <section>
      <CountdownTimer endTime={moment(enrolmentInfo.periodEnd).valueOf()} onTimeout={null} />
      <p>
        {intl.formatMessage(messages.dashboard.enrolment.enrolmentDurationDescription, {
          startDate: moment(enrolmentInfo.periodStart).format(),
          endDate: formatDate(enrolmentInfo.periodEnd),
        })}
      </p>
    </section>
    <footer>
      <p>
        <Button primary to="/shop/enrolment">
          {intl.formatMessage(messages.startShoppingDescription)}
        </Button>
        <Button to="/needHelp" secondary>
          {intl.formatMessage(messages.learnMoreDescription)}
        </Button>
      </p>
    </footer>
  </article>
));

BenefitEnrolment.propTypes = {
  enrolmentInfo: PropTypes.shape({
    periodEnd: PropTypes.string.isRequired,
    periodStart: PropTypes.string.isRequired,
  }),
  healthDeclarationForm: PropTypes.object,
};

export default BenefitEnrolment;



// WEBPACK FOOTER //
// ./components/dashboard/widgets/BenefitEnrolment.js